<template>
    <div class="user-menu">
        <a @click.prevent="selectMenu('prev')" href="#" class="user-menu__nav prev"></a>
        <div class="user-menu__wrap">
            <div class="user-menu__scroll">
                <router-link class="user-menu-link" active-class="active" @click.prevent="setPointer" to="/">Уведомления</router-link>
                <router-link class="user-menu-link" active-class="active" @click.prevent="setPointer" to="/history/">История</router-link>
                <router-link class="user-menu-link" active-class="active" @click.prevent="setPointer" to="/bills/">Счета</router-link>
                <router-link class="user-menu-link" active-class="active" @click.prevent="setPointer" to="/feedback/">Обращения</router-link>
                <router-link class="user-menu-link" active-class="active" @click.prevent="setPointer" to="/doc/">Документы</router-link>
                <router-link v-if="showInstallment" class="user-menu-link" active-class="active" @click.prevent="setPointer" to="/installment/">Рассрочка</router-link>
                <span class="user-menu__pointer"></span>
            </div>
        </div>
        <a @click.prevent="selectMenu('next')" href="#" class="user-menu__nav next"></a>
    </div>
</template>

<script>
export default {
    name: 'user-menu',
    data() {
        return {
            scrollPos: 0,
            scrollX: 0,
            currentPage: this.$route.href
        }
    },
    computed: {
        currentAccount() {
            return this.$store.state.currentAccount
        },
        showInstallment() {
            let activeAccount = this.$store.state.currentAccount

            if (!activeAccount) {
                const accounts = this.$store.state.accounts
                const selectAccount = this.$store.state.selectAccount

                if (selectAccount && accounts.length) {
                    let normalizedTarget = String(selectAccount).replace(/^0+/, '')
                    activeAccount = accounts.find(acc => {
                        let normalizedClient = String(acc.client_number).replace(/^0+/, '')
                        return normalizedClient == normalizedTarget
                    })
                }

                if (!activeAccount && accounts.length)
                    activeAccount = accounts[0]
            }

            return this.$store.getters.canInstallment(activeAccount)
        },
        pages() {
            let pages = ['/', '/history/', '/bills/', '/feedback/', '/doc/']

            if (this.showInstallment)
                pages.push('/installment/')

            return pages
        },
    },
    watch: {
        scrollX() {
            console.log(this.scrollX)
        },
        '$route'() {
            this.currentPage = this.$route.fullPath
            this.$nextTick(() => {
                this.updatePointer()
            })
        }
    },
    mounted() {
        this.currentPage = this.$route.fullPath
        this.updatePointer()
        this.scrollMenu()
    },
    methods: {
        updatePointer() {
            let active = document.querySelector('.user-menu .router-link-exact-active')
                || document.querySelector('.user-menu .router-link-active')

            if (active) {
                this.setPointer(active, true)
            }
        },
        setPointer(e, mounted) {
            let userMenu = document.getElementsByClassName('user-menu__scroll')[0]
            let menuPointer = document.getElementsByClassName('user-menu__pointer')[0]

            let wWidth = window.innerWidth
            let addLeft = 0

            let element
            if (!mounted)
                element = e.target
            else
                element = e

            if (element && userMenu) {
                let elementLeft = element.getBoundingClientRect().left
                let userMenuLeft = userMenu.getBoundingClientRect().left 
                let elementWidth = element.offsetWidth

                menuPointer.style.width = elementWidth + 'px'
                menuPointer.style.left = elementLeft - userMenuLeft + 'px'
            }
        },
        selectMenu(direct) {
            this.pages.forEach((val, i) => {
                switch (direct) {
                    case 'next':
                        if (val == this.$route.href && this.pages[i + 1]) {
                            this.$router.push(this.pages[i + 1])
                            this.currentPage = this.pages[i + 1]
                        }
                        break;
                    case 'prev':
                        if (val == this.$route.href && this.pages[i - 1]) {
                            this.$router.push(this.pages[i - 1])
                            this.currentPage = this.pages[i - 1]
                        }    
                        break;
                }
            })

            this.scrollMenu(direct)
        },
        scrollMenu(direct) {
            let scrollBlock = document.getElementsByClassName('user-menu__scroll')[0]

            let _currentItem = Array.prototype.slice.call(document.getElementsByClassName('user-menu-link'))
            let currentItem
            _currentItem.forEach((val, i) => {
                if (val.getAttribute('href') == this.currentPage) {
                    currentItem = _currentItem[i]
                }
            })
            
            if (!currentItem || !scrollBlock) return

            // Reset scroll to calculate correct position
            scrollBlock.scrollLeft = 0

            let targetScrollLeft = currentItem.offsetLeft - (scrollBlock.offsetWidth - currentItem.offsetWidth) / 2

            // Clamp to valid range
            targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, scrollBlock.scrollWidth - scrollBlock.offsetWidth))

            scrollBlock.scrollLeft = targetScrollLeft
        }
    }
}
</script>